import Keycloak from "keycloak-js";
import { clearTokens, getAccessToken, getRefreshToken, saveTokens } from "./TokenService";
import appConstants, { SESSION_STORAGE_KEYS } from "../appConstants";
import { RMAXLogger } from "../services/LoggerService/RMAXLogger";
import Events from "../utilities/EventEmitter";

const realmName =
  REALMNAMEOVERRIDE || window.location.hostname.replace(/.routemax.com/i, "");
const keycloakUrl =
  KEYCLOAKURLOVERRIDE || "https://" + window.location.hostname + "/auth/";

const _kc = new Keycloak({
  url: keycloakUrl,
  realm: realmName,
  clientId: KEYCLOAKCLIENTID,
});

const initKeycloak = (onAuthenticatedCallback) => {
  _kc
    .init({
      onLoad: "login-required",
      pkceMethod: "S256",
      token: getAccessToken(),
      refreshToken: getRefreshToken(),
      // enableLogging: true
    })
    .then(
      (authenticated) => {
        if (authenticated) {
          saveTokens({
            access_token: _kc.token,
            refresh_token: _kc.refreshToken,
          });
          onAuthenticatedCallback();
        } else {
          //Todo: Redirect to routeRenderer, possibly by updating context. Need to move code from Login.js to here
          RMAXLogger.info(`Show login screen`, {
            action:"initKeycloak",
            authenticated:authenticated
          });
          doLogin();
          //Todo: Router needed to be updated to get this working.
        }
      },
      (_rejected) => {
        updateToken();
      }
    );
};

const logout = () => {
  RMAXLogger.info('logout', {
    action :"logout",
  });
  clearTokens();
  localStorage.removeItem("user");
  sessionStorage.removeItem("selectedTerminal");
  sessionStorage.removeItem("newShipments");
  sessionStorage.removeItem(SESSION_STORAGE_KEYS.ACTIVE_SETTINGS_MODULE);
  _kc.logout({ redirectUri: window.location.origin });
};

const doLogin = () => _kc.login();

const isLoggedIn = () => !!_kc.token;

const hasAccessTokenExpired = () => _kc.isTokenExpired();

const updateToken = () =>
  _kc
    .updateToken(60)
    .then((refreshed) => {
      if (refreshed) {
        // Save tokens if successfully refreshed
        saveTokens({
          access_token: _kc.token,
          refresh_token: _kc.refreshToken,
        });
      }
      return Promise.resolve();
    })
    .catch((error) => {
      // Show login screen otherwise.
      RMAXLogger.info(`Show login screen`, {
        action:"updateToken",
        error:error
      });
      doLogin();
    });

const getUsername = () => _kc.tokenParsed?.name || _kc.tokenParsed?.email;

const handleUserAccess = () => {
  Events.emit('NavigateToAccessDenied', appConstants.NAV_URLS.ACCESS_DENIED)
};

// This is called automatically once token has expired (but no action is done yet on UI by user to refresh it)
_kc.onTokenExpired = () => updateToken();

const AuthService = {
  initKeycloak,
  isLoggedIn,
  doLogin,
  updateToken,
  getUsername,
  logout,
  hasAccessTokenExpired,
  handleUserAccess,
};

export default AuthService;
